<template>
    <div>
        <q-tabs
            v-model="tab"
            inline-label
            active-color="primary"
            indicator-color="primary"
            align="justify"
            class="bg-grey-2 text-grey shadow-2"
        >
            <q-tab name="transactions" icon="fas fa-cash-register" :label="$t('transactions.menu.index')"/>
            <q-tab name="wallets" icon="fa fa-wallet" :label="$t('wallet-addresses.menu.list')" v-if="account.type !== 'Cash'"/>
        </q-tabs>

        <q-separator/>

        <q-tab-panels v-model="tab" animated>
            <q-tab-panel name="transactions">
                <transactions-history :rebit-account-id="account.id" :rebit-account-currency="account.currency.acronym"/>
            </q-tab-panel>
            <q-tab-panel name="wallets" v-if="account.type !== 'Cash'">
                <wallet-address-list :rebit-account-id="account.id"/>
            </q-tab-panel>
        </q-tab-panels>
    </div>
</template>
<script>

import WalletAddressList from '../wallet_addresses/Index.vue'

export default {
    name: "RebitAccountDetails",
    props: {
        account: {
            type: Object,
            required: true
        }
    },
    computed: {},
    data() {
        return {
            tab: 'transactions',
        }
    },
    methods: {},
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {
        WalletAddressList,
        transactionsHistory: () => import('Modules/Transaction/resources/pages/History.vue'),
    },
}
</script>

